<template>
  <v-form
    id="contactDetails"
    v-model="valid"
  >
    <h2 class="header">
      Contact Details
    </h2>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="candidate.mobile"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Mobile*"
          filled
          :rules="[ ...Rules.required, ...Rules.phone]"
          :error-messages="pgError.contact.mobile"
          @keyup="resetErrorMessage('mobile')"
        />
        <v-text-field
          v-model="candidate.email"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Email*"
          filled
          :readonly="hidePasswordField"
          :rules="[...Rules.required, ...Rules.email]"
          :error-messages="pgError.contact.email"
          @keyup="resetErrorMessage('email')"
        />

        <v-text-field
          v-if="!hidePasswordField"
          v-model="candidate.password"
          class="textField"
          filled
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Create Password*"
          :rules="[
            ...Rules.required,
            ...Rules.password,
            !password_match ? 'Your passwords don\'t match' : true
          ]"
          hint="Password must be a minimum of 8 characters"
          counter
          @input="checkPasswordsMatch"
          @click:append="show1 = !show1"
        />
        <v-text-field
          v-if="!hidePasswordField"
          v-model="confirmPassword"
          class="textField"
          filled
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show2 ? 'text' : 'password'"
          name="input-10-1"
          label="Confirm Password*"
          :rules="[
            ...Rules.password,
            !password_match ? 'Your passwords don\'t match' : true
          ]"
          counter
          @input="checkPasswordsMatch"
          @click:append="show2 = !show2"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="candidate.address_one"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Address 1*"
          filled
          :rules="[...Rules.required, ...Rules.alphaNumericDashSpace]"
          :error-messages="pgError.contact.address1"
          @keyup="resetErrorMessage('address1')"
        />
        <v-text-field
          v-model="candidate.address_two"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Address 2*"
          filled
          :rules="[...Rules.required, ...Rules.alphaNumericDashSpace]"
          :error-messages="pgError.contact.address2"
          @keyup="resetErrorMessage('address2')"
        />
        <v-text-field
          v-model="candidate.address_three"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Address 3"
          filled
          :rules="Rules.alphaNumericDashSpace"
        />
        <v-autocomplete
          v-model="candidate.country"
          :disabled="candidate.is_synced === 1"
          class="textField"
          filled
          :items="countries"
          item-text="name"
          item-value="name"
          label="Country*"
          :rules="Rules.required"
        />
        <v-text-field
          v-model="candidate.postcode"
          :disabled="candidate.is_synced === 1"
          class="textField"
          label="Postcode*"
          filled
          :rules="[...Rules.required, ...Rules.postcode]"
          :counter="8"
          :error-messages="pgError.contact.postCode"
          @keyup="resetErrorMessage('postCode')"
        />
      </v-col>
    </v-row>
    <v-btn
      tile
      outlined
      color="agency-color-secondary"
      @click="goBack()"
    >
      Back
    </v-btn>
    <v-btn
      :disabled="!valid"
      tile
      dark
      color="agency-color-primary"
      @click="validatePostCode()"
    >
      Next
    </v-btn>
  </v-form>
</template>
<script>
export default {
  name: 'ContactDetails',
  props: {
    candidate: {
      type: Object,
      default: () => {
        return {
          candidate_details: {},
          candidate_nok: {}
        }
      }
    },
    logDetail: {
      type: Object,
      default: () => {
        return {}
      }
    },
    existAccount: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    pgError: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    show1: false,
    show2: false,
    timeout: '',
    password_match: false,
    valid: false,
    countries: [],
    confirmPassword: '',
    hidePasswordField: false
  }),
  created () {
    this.isLoggedIn()
    const context = this
    axios.get(context.URLs.core.countries.root)
      .then(
        response => {
          context.countries = response.data
        }
      )
  },
  methods: {
    next () {
      this.$emit('next', {
        newCandidate: this.candidate
      })
      localStorage.setItem('candidate_register', JSON.stringify(this.candidate))
    },
    goBack () {
      this.$emit('back')
    },
    checkPasswordsMatch () {
      const context = this
      clearTimeout(context.timeout)
      context.timeout = setTimeout(function () {
        context.password_match = context.candidate.password === context.confirmPassword
      }, 500)
    },
    resetErrorMessage (field) {
      switch (field) {
        case 'mobile':
          this.pgError.contact.mobile = ''
          break
        case 'address1':
          this.pgError.contact.address1 = ''
          break
        case 'address2':
          this.pgError.contact.address2 = ''
          break
        case 'postCode':
          this.pgError.contact.postCode = ''
          break
        case 'email':
          this.pgError.contact.email = ''
          break
      }
    },
    async validatePostCode () {
      if (this.isLoggedIn()) {
        if ('postcode' in this.candidate && this.candidate.postcode !== '') {
          await window.axios.get('/validate-postcode?postcode=' + this.candidate.postcode)
            .then(response => {
              if (response.data.message === 'success') {
                this.next()
              }
            }).catch((error) => {
              this.pgError.contact.postCode = error.response.data.errors
            })
        }
      }
    },
    isLoggedIn () {
      if ('id' in this.candidate && this.candidate.id !== '') {
        const errMsg = 'Please login to register with the email id.'
        window.axios.get('/check-last-active')
          .then(response => {
            if (response.data.message === 'logged') {
              if (response.data.login_user === this.candidate.email) {
                this.hidePasswordField = true
                return true
              } else {
                this.pgError.contact.email = 'You have logged in with different email id: ' +
                    response.data.login_user
              }
            }
          }).catch(() => {
            this.pgError.contact.email = errMsg
            return false
          })
      }
      return true
    }
  }
}
</script>
